<template>
  <div class="player-container">
    <video
      ref="videoPlayer"
      class="video-player"
      autoplay
      controls
      @click="handleClick"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
      @pause="showPlayButton = true"
      @play="showPlayButton = false"
      :poster="selectedThumbnail"
    >
      <source :src="currentEpisode.viedoUrl_H" type="video/mp4" />
      متصفحك لا يدعم تشغيل الفيديو.
    </video>
    <div v-if="showPlayButton" class="overlay">
      <div class="play-button" @click="togglePlay"></div>
    </div>
    <div class="info-bar">
      <span class="title" @click="showEpisodeSelection = true">{{
        title
      }}</span>
      <span class="episode" @click="showEpisodeSelection = true">
        الحلقة رقم{{ episode }}</span
      >
      <button class="follow-button">تابع المسلسل</button>
    </div>

    <!-- Popup for episode selection -->
    <van-popup
      v-model="showEpisodeSelection"
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="popup-header">
        <img :src="selectedThumbnail" alt="صورة مصغرة" class="thumbnail" />
        <div class="popup-info">
          <h3>{{ title }}</h3>
          <p>عدد الحلقات: {{ episodes.length }}</p>
        </div>
      </div>
      <van-grid :column-num="4" :gutter="10" clickable>
        <van-grid-item
          v-for="ep in episodes"
          :key="ep.index"
          :class="{ 'selected-episode': ep === episode }"
          @click="selectEpisode(ep)"
        >
          {{ ep.index }}
          <span v-if="ep === episode" class="playing-indicator">
            <span></span><span></span><span></span>
          </span>
        </van-grid-item>
      </van-grid>
      <div class="popup-footer"></div>
    </van-popup>
  </div>
</template>

<script>
import { Grid, GridItem, Popup } from "vant";
import { getMovieDetail, getPlayDetail } from "../api/api";

export default {
  name: "VideoPlayer",
  components: {
    "van-grid": Grid,
    "van-grid-item": GridItem,
    "van-popup": Popup,
  },
  data() {
    return {
      title: "عنوان مثال",
      episode: "1",
      touchStartX: 0,
      touchStartTime: 0,
      showPlayButton: false,
      clickTimeout: null,
      showEpisodeSelection: false,
      episodes: [], // حلقات مثال
      selectedThumbnail: "",
      currentEpisode: null,
    };
  },
  created() {
    this.fetchMovieDetails();
  },
  methods: {
    handleClick() {
      if (this.clickTimeout) {
        clearTimeout(this.clickTimeout);
        this.clickTimeout = null;
        this.togglePlay();
      } else {
        this.clickTimeout = setTimeout(() => {
          this.clickTimeout = null;
        }, 300);
      }
    },
    togglePlay() {
      console.log("togglePlay called");
      const video = this.$refs.videoPlayer;
      if (video.paused) {
        video.play();
        this.showPlayButton = false;
      } else {
        video.pause();
        this.showPlayButton = true;
      }
    },
    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchStartTime = event.timeStamp;
    },
    handleTouchMove(event) {
      const touchEndX = event.touches[0].clientX;
      const deltaX = touchEndX - this.touchStartX;
      const video = this.$refs.videoPlayer;
      const duration = video.duration;
      const newTime =
        video.currentTime + (deltaX / window.innerWidth) * duration;
      video.currentTime = Math.min(Math.max(newTime, 0), duration);
    },
    handleTouchEnd(event) {
      const touchDuration = event.timeStamp - this.touchStartTime;
      if (touchDuration < 500) {
        return;
      }
    },
    selectEpisode(ep) {
      this.episode = ep;
      this.showEpisodeSelection = false;
    },
    fetchMovieDetails() {
      const movieId = this.$route.query.id;
      if (movieId) {
        this.getMovieDetail(movieId);
      } else {
        console.error("未找到电影ID");
      }
    },
    async getMovieDetail(movieId) {
      try {
        const response = await getMovieDetail(movieId);
        console.log(response.data);
        this.title = response.data.title;
        this.episodes = response.data.chapters;
        this.selectedThumbnail = response.data.cover;
        const playResponse = await getPlayDetail(this.episodes[0].id);
        this.currentEpisode = playResponse.data;
      } catch (error) {
        console.error("获取影片详情失败:", error);
      }
    },
  },
};
</script>

<style scoped>
.player-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  background-color: #f8f9fa;
}

.video-player {
  width: 100%;
  height: calc(100vh - 60px);
  object-fit: contain;
  background-color: #000;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
}

.play-button {
  width: 50px;
  height: 50px;
  background: #007bff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.play-button::before {
  content: "";
  display: block;
  width: 0;
  height: 0;
  border-left: 15px solid #ffffff;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  margin-left: 5px;
}

.play-text {
  color: white;
  margin-top: 10px;
}

.info-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #0056b3;
  color: #ffffff;
  height: 60px;
  box-sizing: border-box;
  padding: 0 10px;
}

.title,
.episode {
  flex: 1;
  padding: 0 10px;
  font-size: 16px;
}

.follow-button {
  background-color: #007bff;
  border: none;
  color: #ffffff;
  padding: 5px 15px;
  cursor: pointer;
  flex-shrink: 0;
  border-radius: 5px;
}

.popup-header {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #e9ecef;
  border-bottom: 1px solid #ced4da;
  margin-bottom: 20px;
}

.thumbnail {
  width: 60px;
  height: 60px;
  margin-right: 15px;
  border-radius: 5px;
  object-fit: cover;
  flex-shrink: 0;
}

.popup-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.popup-info h3 {
  margin: 0;
  font-size: 18px;
  color: #343a40;
}

.popup-info p {
  margin: 5px 0 0;
  font-size: 14px;
  color: #6c757d;
}

::v-deep .selected-episode .van-grid-item__content {
  background-color: #007bff !important;
  color: white;
}

.playing-indicator {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 16px;
  height: 12px;
  position: absolute;
  top: 5px;
  right: 5px;
}

.playing-indicator span {
  display: block;
  width: 3px;
  background-color: #ffc107;
  animation: bounce 1s infinite ease-in-out;
}

.playing-indicator span:nth-child(1) {
  animation-delay: 0s;
}

.playing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}

.playing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%,
  100% {
    height: 2px;
  }
  50% {
    height: 12px;
  }
}

.popup-footer {
  height: 60px;
}
</style>